package ru.villawonka.app.presentation.screens.settings.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.model.LanguageUIModel

sealed interface SettingsUIState : UIState {

    data object Loading : SettingsUIState

    data class Error(val failure: NetworkFailure) : SettingsUIState

    data class Data(
        val language: LanguageUIModel?,
        val country: CountryUIModel?,
        val currency: CurrencyUIModel?,
        val appVersion: String,
    ) : SettingsUIState
}